var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 693,
    viewBox: "0 0 531 693",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.791 270.927C475.624 256.956 455.725 247.939 434.502 244.968C429.164 244.266 424.131 242.093 419.971 238.697C415.812 235.301 412.693 230.817 410.968 225.752C409.242 220.687 408.979 215.243 410.208 210.038C411.437 204.832 414.108 200.071 417.921 196.295C461.17 153.591 466.334 84.1262 425.99 38.7378C415.603 27.0431 402.919 17.5798 388.716 10.9292C374.513 4.27852 359.09 0.580804 343.396 0.0630864C327.701 -0.454631 312.066 2.21858 297.449 7.91856C282.833 13.6186 269.544 22.225 258.399 33.2095L35.6178 253.221C-7.02615 295.324 -12.7954 363.627 26.0159 409.096C43.6656 429.886 68.2482 443.69 95.2871 447.994C100.608 448.745 105.613 450.953 109.742 454.37C113.87 457.788 116.957 462.279 118.658 467.342C120.359 472.404 120.606 477.837 119.371 483.031C118.136 488.225 115.468 492.975 111.667 496.747C68.4177 539.452 63.2537 608.916 103.598 654.305C113.987 665.991 126.671 675.445 140.872 682.089C155.073 688.732 170.491 692.424 186.181 692.938C201.87 693.452 217.5 690.777 232.111 685.077C246.722 679.378 260.006 670.774 271.148 659.793L497.359 436.417C508.472 425.471 517.191 412.366 522.969 397.92C528.747 383.475 531.459 368 530.937 352.466C530.414 336.932 526.667 321.671 519.932 307.641C513.196 293.611 503.616 281.112 491.791 270.927Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo-background.4b83d1e5926948a34448d7ea2566c986.svg";
export { ForwardRef as ReactComponent };